export const SUPPORT_TRANSLATIONS = {
  "fr": {
    "support.copy.001": "Les engagements du soutien",
    "support.copy.002": "Entièrement volontaire",
    "support.copy.003": "Un seul versement",
    "support.copy.004": "Aucun abonnement",
    "support.copy.005": "Eternua",
    "support.copy.006": "Le lien humain, une ambition partagée",
    "support.copy.007": "SOUTENIR LE PROJET",
    "support.copy.008": "Un petit geste.",
    "support.copy.009": "Pour faire vivre",
    "support.copy.010": "Eternua.",
    "support.copy.011": "Les belles rencontres commencent par un lien. Votre soutien aide à lui donner une place.",
    "support.copy.012": "Une plateforme française du lien humain, pour faciliter les rencontres, l’entraide et les échanges. Un projet qui se construit aussi avec vous.",
    "support.copy.013": "Soutenir Eternua",
    "support.copy.014": "Découvrir l’intention",
    "support.copy.015": "Les contributions financières ne sont pas encore ouvertes. Aucun paiement n’est possible actuellement.",
    "support.copy.016": "Eternua, le lien humain au cœur du projet",
    "support.copy.017": "ETERNUA",
    "support.copy.018": "UNE AMBITION PARTAGÉE",
    "support.copy.019": "Un lien.",
    "support.copy.020": "Mille possibles.",
    "support.copy.021": "Des rencontres. De l’entraide.",
    "support.copy.022": "Et un avenir à imaginer ensemble.",
    "support.copy.023": "LE LIEN HUMAIN AU CŒUR",
    "support.copy.024": "L’INTENTION, CONCRÈTEMENT",
    "support.copy.025": "Faire vivre l’essentiel.",
    "support.copy.026": "Ouvrir des possibles.",
    "support.copy.027": "Soutenir Eternua, c’est contribuer à son fonctionnement et à son amélioration. Voici ce qui anime le projet.",
    "support.copy.028": "LA PLATEFORME",
    "support.copy.029": "Le lien humain,",
    "support.copy.030": "chaque jour.",
    "support.copy.031": "Contribuer à l’hébergement, à la maintenance et aux améliorations d’Eternua, pour rendre les rencontres, l’entraide et les échanges plus simples sur ordinateur comme sur mobile.",
    "support.copy.032": "Rencontrer · Partager · Avancer",
    "support.copy.033": "LIA · AUJOURD’HUI",
    "support.copy.034": "Une présence",
    "support.copy.035": "pour vous orienter.",
    "support.copy.036": "LIA vous accueille sur le site et vous aide à trouver votre chemin parmi les services d’Eternua. Le projet avance avec vos usages et vos retours, au service des relations entre les personnes.",
    "support.copy.037": "Accueillir · Orienter · Relier",
    "support.copy.038": "AELITH · LE FUTUR",
    "support.copy.039": "Une ambition",
    "support.copy.040": "à explorer.",
    "support.copy.041": "Aelith est le futur démonstrateur humanoïde envisagé pour explorer l’accueil et l’orientation dans le monde physique. Sa conception, ses capacités et sa validation restent à construire.",
    "support.copy.042": "Imaginer · Concevoir · Éprouver",
    "support.copy.043": "Le soutien contribue au fonctionnement global d’Eternua, sans affectation dédiée à Aelith. Aelith n’est pas disponible aujourd’hui : aucune date de lancement ni livraison n’est annoncée. Aucun pourcentage d’affectation ni résultat futur n’est promis.",
    "support.copy.044": "BIEN PLUS QU’UN GESTE FINANCIER",
    "support.copy.045": "Votre présence",
    "support.copy.046": "compte aussi.",
    "support.copy.047": "Une rencontre, un retour, un projet que l’on fait découvrir. Vous pouvez faire grandir Eternua à votre façon, sans verser de pourboire.",
    "support.copy.048": "Faire vivre les échanges",
    "support.copy.049": "Explorer les services et prendre part à la vie d’Eternua.",
    "support.copy.050": "Faire découvrir le projet",
    "support.copy.051": "Découvrir notre intention et en parler autour de vous.",
    "support.copy.052": "Partager votre regard",
    "support.copy.053": "Nous dire ce qui vous aide et ce qui pourrait être amélioré.",
    "support.copy.054": "À VOTRE MESURE",
    "support.copy.055": "UNE SUGGESTION, SIMPLEMENT",
    "support.copy.056": "UN GESTE LIBRE",
    "support.copy.057": "Le choix reste",
    "support.copy.058": "toujours le vôtre.",
    "support.copy.059": "Après avoir utilisé les services d’Eternua, un pourboire facultatif est une façon de remercier cette expérience. La suggestion de 10 € n’est jamais une obligation.",
    "support.copy.060": "Les contributions financières ne sont pas encore ouvertes.",
    "support.copy.061": "Découvrir le parcours de soutien",
    "support.copy.062": "EN TOUTE CLARTÉ",
    "support.copy.063": "Quelques réponses,",
    "support.copy.064": "tout simplement.",
    "support.copy.065": "Le soutien donne-t-il accès à Premium ?",
    "support.copy.066": "Non. Le pourboire est indépendant de Premium. Il est entièrement volontaire, sans abonnement ni contrepartie supplémentaire.",
    "support.copy.067": "Puis-je participer sans verser de pourboire ?",
    "support.copy.068": "Oui. Utiliser les services, faire découvrir le projet et partager vos retours sont aussi des façons de participer. Le pourboire reste facultatif.",
    "support.copy.069": "À quoi contribue mon soutien ?",
    "support.copy.070": "Au fonctionnement global d’Eternua : hébergement, maintenance et améliorations. Il ne s’agit pas d’un financement dédié à Aelith et aucun résultat futur n’est promis.",
    "support.copy.071": "Nature de la contribution",
    "support.copy.072": "Un pourboire facultatif pour les services d’Eternua déjà utilisés, sans abonnement ni contrepartie supplémentaire : il n’active pas Premium. Il ne s’agit pas d’une collecte caritative ; aucun reçu fiscal ni avantage fiscal n’est promis.",
    "support.copy.073": "Vous cherchez de l’aide sur votre compte ?",
    "support.copy.074": "Contacter l’assistance",
    "support.copy.075": "Pourboire indisponible",
    "support.copy.076": "Ce parcours est désactivé dans cette configuration. Aucun paiement ne peut être lancé depuis cette page.",
    "support.copy.077": "Continuer sans pourboire",
    "support.copy.078": "RETOUR SUR ETERNUA",
    "support.copy.079": "Vous êtes de retour.",
    "support.copy.080": "Aucun paiement n’est confirmé sur cette page.",
    "support.copy.081": "Le retour depuis Stripe ne prouve pas qu’un paiement a été effectué ou annulé.",
    "support.copy.082": "Ne relancez pas une opération uniquement parce que vous êtes revenu ici. En cas de doute,",
    "support.copy.083": "contactez l’assistance",
    "support.copy.084": "avant de recommencer. Un pourboire ne donne pas accès à Premium.",
    "support.copy.085": "Revenir à la page de soutien",
    "support.copy.086": "Retour à l’accueil",
    "support.copy.087": "Soutenir les projets Eternua",
    "support.copy.088": "Quatre collectes distinctes, flexibles et sans date de fin. Choisissez le projet dont vous souhaitez suivre l’évolution.",
    "support.copy.089": "Soutien général à Eternua",
    "support.copy.090": "Le soutien général et son historique restent distincts de ces quatre collectes. Aucun don général n’est réaffecté automatiquement.",
    "support.return.hosted": "Pour le pourboire hébergé, vérifiez la confirmation ou le reçu fourni par Stripe. Aucun statut de paiement n’est récupéré sur cette page.",
    "support.return.sandbox": "Cette configuration est réservée aux essais et ne confirme aucun pourboire réel.",
    "support.return.closed": "Le parcours est actuellement désactivé."
  },
  "en": {
    "support.copy.001": "Support commitments",
    "support.copy.002": "Entirely voluntary",
    "support.copy.003": "One contribution",
    "support.copy.004": "No subscription",
    "support.copy.005": "Eternua",
    "support.copy.006": "Human connection, a shared ambition",
    "support.copy.007": "SUPPORT THE PROJECT",
    "support.copy.008": "A small gesture.",
    "support.copy.009": "To help sustain",
    "support.copy.010": "Eternua.",
    "support.copy.011": "Meaningful encounters begin with a connection. Your support helps make room for it.",
    "support.copy.012": "A French platform for human connection, making it easier to meet, help each other and exchange. A project built with you, too.",
    "support.copy.013": "Support Eternua",
    "support.copy.014": "Discover our intention",
    "support.copy.015": "Financial contributions are not open yet. No payment is currently possible.",
    "support.copy.016": "Eternua, human connection at the heart of the project",
    "support.copy.017": "ETERNUA",
    "support.copy.018": "A SHARED AMBITION",
    "support.copy.019": "One connection.",
    "support.copy.020": "A thousand possibilities.",
    "support.copy.021": "Encounters. Mutual aid.",
    "support.copy.022": "And a future to imagine together.",
    "support.copy.023": "HUMAN CONNECTION AT THE HEART",
    "support.copy.024": "OUR INTENTION IN PRACTICE",
    "support.copy.025": "Sustain what matters.",
    "support.copy.026": "Open up possibilities.",
    "support.copy.027": "Supporting Eternua contributes to its operation and improvement. Here is what drives the project.",
    "support.copy.028": "THE PLATFORM",
    "support.copy.029": "Human connection,",
    "support.copy.030": "every day.",
    "support.copy.031": "Contribute to Eternua’s hosting, maintenance and improvements, making encounters, mutual aid and exchanges easier on desktop and mobile.",
    "support.copy.032": "Meet · Share · Move forward",
    "support.copy.033": "LIA · TODAY",
    "support.copy.034": "A presence",
    "support.copy.035": "to help you find your way.",
    "support.copy.036": "LIA welcomes you to the site and helps you find your way through Eternua’s services. The project evolves with your use and feedback, in support of relationships between people.",
    "support.copy.037": "Welcome · Guide · Connect",
    "support.copy.038": "AELITH · THE FUTURE",
    "support.copy.039": "An ambition",
    "support.copy.040": "to explore.",
    "support.copy.041": "Aelith is a proposed future humanoid demonstrator for exploring welcome and guidance in the physical world. Its design, capabilities and validation remain to be developed.",
    "support.copy.042": "Imagine · Design · Test",
    "support.copy.043": "Support contributes to Eternua’s general operation, without an allocation dedicated to Aelith. Aelith is not available today: no launch or delivery date is announced. No allocation percentage or future result is promised.",
    "support.copy.044": "MORE THAN A FINANCIAL GESTURE",
    "support.copy.045": "Your presence",
    "support.copy.046": "matters too.",
    "support.copy.047": "An encounter, feedback, a project you share with others. You can help Eternua grow in your own way, without leaving a tip.",
    "support.copy.048": "Bring exchanges to life",
    "support.copy.049": "Explore the services and participate in Eternua’s community.",
    "support.copy.050": "Introduce others to the project",
    "support.copy.051": "Discover our intention and share it with people around you.",
    "support.copy.052": "Share your perspective",
    "support.copy.053": "Tell us what helps you and what could be improved.",
    "support.copy.054": "AT YOUR OWN PACE",
    "support.copy.055": "SIMPLY A SUGGESTION",
    "support.copy.056": "A VOLUNTARY GESTURE",
    "support.copy.057": "The choice remains",
    "support.copy.058": "yours, always.",
    "support.copy.059": "After using Eternua’s services, an optional tip is a way to say thank you for that experience. The suggested €10 is never an obligation.",
    "support.copy.060": "Financial contributions are not open yet.",
    "support.copy.061": "Discover the support process",
    "support.copy.062": "WITH FULL CLARITY",
    "support.copy.063": "A few answers,",
    "support.copy.064": "quite simply.",
    "support.copy.065": "Does support give access to Premium?",
    "support.copy.066": "No. Tips are independent of Premium. They are entirely voluntary, with no subscription or additional benefit in return.",
    "support.copy.067": "Can I participate without leaving a tip?",
    "support.copy.068": "Yes. Using the services, introducing others to the project and sharing feedback are also ways to participate. Tips remain optional.",
    "support.copy.069": "What does my support contribute to?",
    "support.copy.070": "Eternua’s general operation: hosting, maintenance and improvements. This is not funding dedicated to Aelith, and no future result is promised.",
    "support.copy.071": "Nature of the contribution",
    "support.copy.072": "An optional tip for Eternua services already used, with no subscription or additional benefit in return: it does not activate Premium. This is not a charitable fundraiser; no tax receipt or tax benefit is promised.",
    "support.copy.073": "Need help with your account?",
    "support.copy.074": "Contact support",
    "support.copy.075": "Tips unavailable",
    "support.copy.076": "This process is disabled in this configuration. No payment can be started from this page.",
    "support.copy.077": "Continue without a tip",
    "support.copy.078": "BACK ON ETERNUA",
    "support.copy.079": "You are back.",
    "support.copy.080": "No payment is confirmed on this page.",
    "support.copy.081": "Returning from Stripe does not prove that a payment was made or cancelled.",
    "support.copy.082": "Do not restart a transaction just because you have returned here. If in doubt,",
    "support.copy.083": "contact support",
    "support.copy.084": "before trying again. A tip does not give access to Premium.",
    "support.copy.085": "Return to the support page",
    "support.copy.086": "Back to home",
    "support.copy.087": "Support Eternua projects",
    "support.copy.088": "Four separate, flexible fundraisers with no end date. Choose the project whose progress you want to follow.",
    "support.copy.089": "General support for Eternua",
    "support.copy.090": "General support and its history remain separate from these four fundraisers. No general donation is automatically reassigned.",
    "support.return.hosted": "For hosted tips, check the confirmation or receipt provided by Stripe. No payment status is retrieved on this page.",
    "support.return.sandbox": "This configuration is for testing only and does not confirm any real tip.",
    "support.return.closed": "This process is currently disabled."
  }
};
